import React, { useState } from 'react';
import styles from './styles.module.css';
import { Button, Grid, TextField, DialogActions, IconButton, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NumberField from 'components/library/NumberField';
import { useTranslation } from 'react-i18next';

function EditOrderActionDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { handleClose, orderAction, updateOrderAction } = props;
  const [action, setAction] = useState(orderAction.action);
  const [order, setOrder] = useState(orderAction.order);

  const updateOrderActions = () => {
    updateOrderAction(orderAction, { action, order: Number(order) });
    handleClose();
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon("Edit order action")}</h2>
          <IconButton onClick={handleClose}><CloseIcon/></IconButton> 
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} sx={{ pt: 0.5 }} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon("Action")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label="Action"
                variant="outlined"
                size="small"
                fullWidth
                value={action}
                onChange={(e) => {
                  setAction(e.target.value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} style={{ pt: 0.5 }} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon("Order")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <NumberField
                value={order}
                onChange={(e) => {
                  setOrder(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" onClick={handleClose} className={styles.closeBtn}>
              {tCommon("Close")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={action === '' || order === ''}
              onClick={updateOrderActions}
            >
              {tCommon("Update")}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default EditOrderActionDialog;
